import { Message, QueryFilter } from '@dinosband/bv-messenger-schema'
import { _trimEnd, _uniq, _isIntersected } from '@dinosband/dbi-utils'

export function _matchFilter (message: Message, filter: QueryFilter | undefined, userId: number): boolean {
  if (!filter) {
    return true
  }
  if (!_matchLocations(message.props.locations, filter.locations)) {
    return false
  }
  if (!_matchKeywords(message.props.analyzedKeyword, filter.matchKeywords)) {
    return false
  }
  if (filter.excludeFinished ?? false) {
    // 주의: messenger-server의 lastMessage에는 jobOfferState가 없으므로 이 검사가 충분하지 않다.
    if ((message as Message).props?.jobOfferState === 'Hired') {
      return false
    }
  }
  if (filter.onlyOwnMessages) {
    if (message.props.userId === userId) {
      return true
    }
    if (filter.includeByAdmin) {
      return message.props.byAdmin ?? false
    }
    return false
  }
  return true
}

function _matchLocations (locations?: string[], filter?: string[]) {
  if (!filter?.length) {
    return true
  }
  const filterLocations = _resolveLocations(filter)
  if (!locations?.length) {
    return filterLocations.includes('')
  }
  if (_isIntersected(locations, filterLocations)) {
    return true
  }
  const asteriskLocations = filterLocations
    .filter((i) => i.endsWith('*'))
    .map((i) => _trimEnd(i, '*') ?? '')
    .filter((i) => i.length)
  return asteriskLocations.some((estra) => locations.some((i) => i.startsWith(estra)))
}

function _matchKeywords (analyzedKeywords?: string[], filter?: string[][]) {
  if (!filter?.length) {
    return true
  }
  const filterKeywords = filter.filter((i) => i.length)
  return filterKeywords.every((keywords) => _isIntersected(keywords, analyzedKeywords))
}

export function _resolveLocations (locations: string[]) {
  const all = locations.reduce((result, i) => [...result, ..._resolveLocation(i)], [] as string[])
  return _uniq(all)
}

function _resolveLocation (location: string) {
  const parts = location.split(' ')
  const result = parts
    .reduce((result, i) => [...result, result[result.length - 1] + ' ' + i], [''])
    .map((i) => i.trim())
  result[result.length - 1] += '*'
  return result
}